module.exports = __webpack_public_path__ + "img/985.84e93de7.gif";